<template>
	<div class="myoutput-list" @mouseenter="changeActive(true)" @mouseleave="changeActive(false)" v-bind:class="{active:item.isActive }">
		<div class="myoutput-list-header">
			<span>{{item.p1.mark}}-{{item.mark}}->{{item.p2.mark}}&nbsp;{{item.desc}}</span>
			<span class="" v-on:click.prevent="selected=!selected">&nbsp;<i class="fa" v-bind:class="{'fa-minus-square-o':selected,'fa-plus-square-o':!selected}"></i></span>
		</div>
		<div class="myoutput-list-body" v-show="selected">
			<div class="input-group input-group-sm">
				<span class="input-group-addon input-group-addon-color">风量</span>
				<div>
					<select class="form-control my-form-control" list="method_list" value='0'>
							<option value="0">{{item.G.toFixed(2)}}(kga/s)</option>
							<option>{{(item.G*3600).toFixed(2)}}(kga/h)</option>
						</select>
				</div>
			</div>
			<div class="input-group input-group-sm">
				<span class="input-group-addon input-group-addon-color">焓差</span>
				<div>
					<select class="form-control my-form-control" list="method_list" value='0'>
							<option value="0">{{item.dh.toFixed(2)}}(kj/kga)</option>
						</select>
				</div>
			</div>
			<div class="input-group input-group-sm">
				<span class="input-group-addon input-group-addon-color">湿差</span>
				<div>
					<select class="form-control my-form-control" list="method_list" value='0'>
							<option value="0">{{(item.d*1000000).toFixed(2)}}(mg/kga)</option>
						</select>
				</div>
			</div>
			<div class="input-group input-group-sm">
				<span class="input-group-addon input-group-addon-color">热量</span>
				<div>
					<select class="form-control my-form-control" list="method_list" value='0'>
							<option value="0">{{(item.G*item.dh).toFixed(2)}}(kw)</option>
						</select>
				</div>
			</div>
			<div class="input-group input-group-sm">
				<span class="input-group-addon input-group-addon-color">湿量</span>
				<div>
					<select class="form-control my-form-control" list="method_list" value='0'>
							<option value="0">{{(item.G*item.d*1000000).toFixed(2)}}(mg/s)</option>
							<option value="0">{{(item.G*item.d*3600).toFixed(2)}}(kg/h)</option>
						</select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['item'],
		data: function () {
			return { selected: false }
		},
		computed: {
			isActive: function () {
				return this.item.isActive;
			}
		},
		methods: {
			changeActive: function (active) {
				this.item.isActive = active
				this.$emit('changeactive', this.item)
			}
		}
	}

</script>

<style>

</style>


// WEBPACK FOOTER //
// line.vue?a4f9cd44